import { useEffect } from 'react';

export const useScrollToTop = (): void => {
  /**
   * Scroll to top only on mount
   */
  useEffect(() => window.scrollTo(0, 0), []);
};
